import CustomTable from "components/CustomTable";
import PageHeader from "components/PageHeader";

import Toolbar from "./components/Toolbar";
import "./index.scss";
import useList from "./useList";

function ListContract() {
  const {
    params,
    handleSearch,
    handleRemoveFilterTag,
    filterTags,
    setFilterTags,
    setParams,
    searchTerm,
    columns,
    handleChangeTable,
    dataSource,
    loading,
    total,
    optionOwnerType,
    optionStatus,
    sellerFilterOptions,
  } = useList();

  return (
    <div className="list-sales-return">
      <PageHeader
        pageTitle="Danh sách hợp đồng"
        routes={[
          { path: "#", name: "Đại lý" },
          { path: "/list-contract", name: "Hợp đồng" },
          { path: "/", name: "Danh sách hợp đồng" },
        ]}
      />
      <div className="campaign-container">
        <Toolbar
          handleSearch={handleSearch}
          handleRemoveFilterTag={handleRemoveFilterTag}
          setFilterTags={setFilterTags}
          filterTags={filterTags}
          setParams={setParams}
          params={params}
          searchTerm={searchTerm}
          optionOwnerType={optionOwnerType}
          optionStatus={optionStatus}
          sellerFilterOptions={sellerFilterOptions}
        />
        <div className="table-list-recommend-import">
          <CustomTable
            columns={columns}
            dataSource={dataSource}
            loading={loading}
            pagination={{
              total,
              current: params.pagination.offset / params.pagination.limit + 1,
              pageSize: params.pagination.limit,
            }}
            onChange={handleChangeTable}
          />
        </div>
      </div>
    </div>
  );
}

export default ListContract;
